module.exports = __webpack_public_path__ + "img/dummyprod5@2x.3a396b67.png";